import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-lO8J1a0C.mjs"));
export {
  FilePickerVue
};
//# sourceMappingURL=index-hTwX2gcC.mjs.map
